import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Codetext from "../../Components/codetext/codetext";
import Bodytext from "../../Components/codetext/bodytext";
import code from "./json/code1.json";
import CopyButton from "../../Components/codetext/copybutton"; // adjust path if needed
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import i18next from 'i18next';
import { useTranslation } from "react-i18next";

export default function Methods() {
  const { t } = useTranslation();
  const [allLanguage, setAllLanguage] = useState("english");

  // Set language according current local
  useEffect(() => {
    i18next.changeLanguage(navigator.language === 'en-US' ? 'en' : 'fr'); // Change the i18next language
    localStorage.setItem("handleSelectedLanguage", navigator.language === 'en-US' ? 'english' : 'guinea');
  }, [navigator.language]);

  // Get handleSelectedLanguage from localStorage
  useEffect(() => {
    const storeHandleSelectedLanguage = localStorage.getItem('handleSelectedLanguage');
    if (storeHandleSelectedLanguage) {
      setAllLanguage(storeHandleSelectedLanguage); // Update state
    }
  }, [localStorage.getItem('handleSelectedLanguage')]); // Runs only on mount

  const [openCollapse, setOpenCollapse] = useState({
    createToken: false,
    initiatePayment: false,
    getpaymentdetails: false,
    initiatetransfer: false,
    getpaymentdetailsbyid: false,
    transfer: false,
  });

  // auth state
  const [contentdata, setcontentdata] = useState({});
  const [createtokenResponses, setcreatetokenResponses] = useState({});

  // collection state
  const [collectiondata, setcollectiondata] = useState({});
  const [collectionResponses, setCollectionResponses] = useState({});
  const [collectionRequest, setCollectionRequest] = useState(null);

  // collection1  state
  const [collectiondata1, setcollectiondata1] = useState({});
  const [collectionResponses1, setCollectionResponses1] = useState({});
  const [collectionRequest1, setCollectionRequest1] = useState(null);

  // transferfunds, transferfundsrequest, transferfundserror state
  const [transferfundsdata, settransferfundsdata] = useState({});
  const [transferfundsResponses, settransferfundsResponses] = useState({});
  const [transferfundsrequest, settransferfundsrequest] = useState(null);

  // transferfunds1, transferfundsrequest1, transferfundserror1 state
  const [transferfundsdata1, settransferfundsdata1] = useState({});
  const [transferfundsResponses1, settransferfundsResponses1] = useState({});
  const [transferfundsrequest1, settransferfundsrequest1] = useState(null);

  // transferfunds2, transferfundsrequest2, transferfundserror2 state
  const [transferfundsdata2, settransferfundsdata2] = useState({});
  const [transferfundsResponses2, settransferfundsResponses2] = useState({});
  const [transferfundsrequest2, settransferfundsrequest2] = useState(null);

  useEffect(() => {

    const createtoken_responseMap = {};
    code[allLanguage === "english" ? 'en' : 'fr'].authdata.response.forEach((res) => {
      const key = Object.keys(res)[0];
      createtoken_responseMap[key] = res[key];
    },[allLanguage]);

    const collection_responseMap = {};
    code[allLanguage === "english" ? 'en' : 'fr'].collectiondata.response.forEach((res) => {
      const key = Object.keys(res)[0];
      collection_responseMap[key] = res[key];
    },[allLanguage]);

    const collection_responseMap1 = {};
    code[allLanguage === "english" ? 'en' : 'fr'].collectiondata1.response.forEach((res) => {
      const key = Object.keys(res)[0];
      collection_responseMap1[key] = res[key];
    },[allLanguage]);

    const transfer_responseMap = {};
    code[allLanguage === "english" ? 'en' : 'fr'].transferfunds.response.forEach((res) => {
      const key = Object.keys(res)[0];
      transfer_responseMap[key] = res[key];
    },[allLanguage]);

    const transfer_responseMap1 = {};
    code[allLanguage === "english" ? 'en' : 'fr'].transferfunds1.response.forEach((res) => {
      const key = Object.keys(res)[0];
      transfer_responseMap1[key] = res[key];
    },[allLanguage]);

    const transfer_responseMap2 = {};
    code[allLanguage === "english" ? 'en' : 'fr'].transferfunds2.response.forEach((res) => {
      const key = Object.keys(res)[0];
      transfer_responseMap2[key] = res[key];
    },[allLanguage]);

    setcontentdata(code[allLanguage === "english" ? 'en' : 'fr'].authdata);
    setcreatetokenResponses(createtoken_responseMap);

    setcollectiondata(code[allLanguage === "english" ? 'en' : 'fr'].collectiondata);
    setCollectionRequest(code[allLanguage === "english" ? 'en' : 'fr'].collectiondata.request);
    setCollectionResponses(collection_responseMap);

    setcollectiondata1(code[allLanguage === "english" ? 'en' : 'fr'].collectiondata1);
    setCollectionRequest1(code[allLanguage === "english" ? 'en' : 'fr'].collectiondata1.request);
    setCollectionResponses1(collection_responseMap1);

    settransferfundsdata(code[allLanguage === "english" ? 'en' : 'fr'].transferfunds);
    settransferfundsrequest(code[allLanguage === "english" ? 'en' : 'fr'].transferfunds.request);
    settransferfundsResponses(transfer_responseMap);

    settransferfundsdata1(code[allLanguage === "english" ? 'en' : 'fr'].transferfunds1);
    settransferfundsrequest1(code[allLanguage === "english" ? 'en' : 'fr'].transferfunds1.request);
    settransferfundsResponses1(transfer_responseMap1);

    settransferfundsdata2(code[allLanguage === "english" ? 'en' : 'fr'].transferfunds2);
    settransferfundsrequest2(code[allLanguage === "english" ? 'en' : 'fr'].transferfunds2.request);
    settransferfundsResponses2(transfer_responseMap2);

  }, []);

  // Initialize state to manage the selected option
  const [selectedOption, setSelectedOption] = useState("option1");
  // Handle change event for select field
  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="mt-5">
      {/**********  Aouth  **********/}
      <div>
        <h4 className="h4-heading">{contentdata.titlename}</h4>
        <p className="p-pera">{contentdata.patacontent}</p>
        <div className="grid grid-cols-2 gap-4">
          <div className="w-full">
            <div className="heading-box">
              <h4 className="h4-heading">{contentdata.titlename1}</h4>
              <p className="p-pera">
                <strong>
                  {contentdata.method} {contentdata.apiname}
                </strong>{" "}
              </p>
              <p className="p-pera">{contentdata.apiurl}</p>
              <p className="p-pera">{contentdata.shortpara}</p>
              <p className="error-heading-pra">{contentdata.header}</p>
              <table>
                <tbody>
                  <tr>
                    <td className="error-t-body error-body-text">
                      {contentdata.contenttype}
                    </td>
                    <td className="error-t-body-head error-body-text">
                      <p className="p-pera">
                        {contentdata.contenttypecontent?.slice(0, 25)}
                        ...
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td className="error-t-body error-body-text">
                      {contentdata.accept}
                    </td>
                    <td className="error-t-body-head error-body-text">
                      <p className="p-pera">{contentdata.acceptcontent}</p>
                    </td>
                  </tr>
                  <tr>
                    <td className="error-t-body error-body-text">
                      {contentdata.origin}
                    </td>
                    <td className="error-t-body-head error-body-text">
                      <p className="p-pera">
                        {contentdata.origincontent?.slice(0, 25)}...
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-full">
            <div className="copy-board-box">
              <div className="code-box">
                <div className="respons-url-box">
                  <p
                    onClick={() =>
                      setOpenCollapse((prev) => ({
                        ...prev,
                        createToken: !prev.createToken,
                      }))
                    }
                    aria-controls="example-collapse-text"
                    aria-expanded={openCollapse.createToken}
                    className="url-but-box"
                  >
                    <>
                      <Button className="but-api-url-method">{t("main.developerDocuments.Post")}</Button>
                      <span className="url-span">/api/pg/create_token</span>
                    </>
                    {openCollapse.createToken ? (
                      <IoIosArrowUp />
                    ) : (
                      <IoIosArrowDown />
                    )}
                  </p>
                  {openCollapse.createToken && (
                    <div id="createToken-collapse" className="collapse-box">
                      <div className="coll-list">
                        <p className="url-show">{contentdata.apiurl}</p>
                        <CopyButton textToCopy={contentdata.apiurl} />
                      </div>
                    </div>
                  )}
                </div>

                <div className="tab-box-outer">
                  <p className="heading-code-box">{t("main.developerDocuments.Response samples")}</p>
                  <Tabs
                    className="mb-3"
                    selectedTabClassName="active response-code-tab"
                    selectedTabPanelClassName="active-panel"
                  >
                    <TabList className="relative identity flex gap-3 items-center nav nav-tabs">
                      {Object.entries(createtokenResponses)
                        .sort(
                          (a, b) =>
                            parseInt(a[0].replace("code", "")) -
                            parseInt(b[0].replace("code", ""))
                        )
                        .map(([codeKey]) => {
                          const tabKey = codeKey.replace("code", "");
                          return (
                            <Tab className="nav-item nav-link" key={codeKey}>
                              {tabKey}
                            </Tab>
                          );
                        })}
                    </TabList>

                    {Object.entries(createtokenResponses)
                      .sort(
                        (a, b) =>
                          parseInt(a[0].replace("code", "")) -
                          parseInt(b[0].replace("code", ""))
                      )
                      .map(([codeKey, responseData]) => (
                        <TabPanel key={codeKey} className="tab-pane">
                          <div className="url-but-box-1">
                            {codeKey === "code200" && (
                              <div className="dropMenu">
                                <select
                                  id="selectField"
                                  onChange={handleSelectChange}
                                  className="select-box"
                                >
                                  <option value="option1" className="option-h">
                                    application/json
                                  </option>
                                  <option value="option2" className="option-h">
                                    text/json
                                  </option>
                                </select>
                              </div>
                            )}
                            <Codetext data={responseData} />
                          </div>
                        </TabPanel>
                      ))}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/**********  Collections  **********/}
      <div>
        <div className="mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="w-full">
              <div className="heading-box">
                <h4 className="h4-heading pt-4">{t("main.developerDocuments.Collections")}</h4>
                <p className="error-heading-pra">{t("main.developerDocuments.Overview")}</p>
                <p className="p-pera">{collectiondata.pra1}</p>
                <p className="error-heading-pra">{t("main.developerDocuments.Purpose")}</p>
                <p className="p-pera">{collectiondata.pra2}</p>
                <p className="p-pera">
                  <strong>{collectiondata.apiname}</strong>
                </p>
                <p className="p-pera">
                  <strong>{t("main.developerDocuments.Method")}</strong> {collectiondata.method}
                </p>
                <p className="p-pera">
                  <strong>{t("main.developerDocuments.Endpoint")}</strong> {collectiondata.apiendponit}
                </p>
                <p className="p-pera">
                  <strong>{t("main.developerDocuments.URL")} </strong>
                  {collectiondata.apiurl}
                </p>

                <p className="error-heading-pra">
                  {t("main.developerDocuments.AUTHORIZATION")} <span>{t("main.developerDocuments.Bearer Token")}</span>
                </p>
                <table>
                  <tbody>
                    <tr>
                      <td className="error-t-body error-body-text">{t("main.developerDocuments.Token")}</td>
                      <td className="error-t-body-head error-body-text">{`<token>`}</td>
                    </tr>
                  </tbody>
                </table>
                <p className="error-heading-pra">{t("main.developerDocuments.HEADERS")}</p>
                <table>
                  <tbody>
                    <tr>
                      <td className="error-t-body error-body-text">
                        {collectiondata.contenttype}
                      </td>
                      <td className="error-t-body-head error-body-text">
                        <p className="p-pera">
                          {collectiondata.contenttypecontent?.slice(0, 25)}
                          ...
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="error-heading-pra">{t("main.developerDocuments.Body")}</p>
                <div className="auth-box">
                  <div className="auth-pera-box">
                    {collectionRequest ? (
                      <Bodytext data={collectionRequest} />
                    ) : (
                      <p>{t("main.developerDocuments.Loading")}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full mt-3">
              <div className="copy-board-box">
                <div className="code-box">
                  <div className="respons-url-box">
                    <p
                      onClick={() =>
                        setOpenCollapse((prev) => ({
                          ...prev,
                          initiatePayment: !prev.initiatePayment,
                        }))
                      }
                      aria-controls="example-collapse-text"
                      aria-expanded={openCollapse.initiatePayment}
                      className="url-but-box"
                    >
                      <>
                        <Button className="but-api-url-method">{t("main.developerDocuments.Post")}</Button>
                        <span className="url-span">
                          /api/pg/pg_initiate_payment
                        </span>
                      </>
                      {openCollapse.initiatePayment ? (
                        <IoIosArrowUp />
                      ) : (
                        <IoIosArrowDown />
                      )}
                    </p>
                    {openCollapse.initiatePayment && (
                      <div
                        id="initiatePayment-collapse"
                        className="collapse-box"
                      >
                        <div className="coll-list">
                          <p className="url-show">{collectiondata.apiurl}</p>
                          <CopyButton textToCopy={collectiondata.apiurl} />
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    <p className="heading-code-box">{t("main.developerDocuments.Response samples")}</p>

                    <Tabs
                      className="mb-3"
                      selectedTabClassName="active response-code-tab"
                      selectedTabPanelClassName="active-panel"
                    >
                      <TabList className="relative identity flex gap-3 items-center nav nav-tabs">
                        {Object.entries(collectionResponses)
                          .sort(
                            (a, b) =>
                              parseInt(a[0].replace("code", "")) -
                              parseInt(b[0].replace("code", ""))
                          )
                          .map(([codeKey]) => {
                            const tabKey = codeKey.replace("code", "");
                            return (
                              <Tab className="nav-item nav-link" key={codeKey}>
                                {tabKey}
                              </Tab>
                            );
                          })}
                      </TabList>

                      {Object.entries(collectionResponses)
                        .sort(
                          (a, b) =>
                            parseInt(a[0].replace("code", "")) -
                            parseInt(b[0].replace("code", ""))
                        )
                        .map(([codeKey, responseData]) => (
                          <TabPanel key={codeKey} className="tab-pane">
                            <div className="url-but-box-1">
                              {codeKey === "code200" && (
                                <div className="dropMenu">
                                  <select
                                    id="selectField"
                                    onChange={handleSelectChange}
                                    className="select-box"
                                  >
                                    <option
                                      value="option1"
                                      className="option-h"
                                    >
                                      application/json
                                    </option>
                                    <option
                                      value="option2"
                                      className="option-h"
                                    >
                                      text/json
                                    </option>
                                  </select>
                                </div>
                              )}
                              <Codetext data={responseData} />
                            </div>
                          </TabPanel>
                        ))}
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="" style={{ marginTop: "120px" }}>
          <div className="grid grid-cols-2 gap-4">
            <div className="w-full">
              <p className="error-heading-pra">{t("main.developerDocuments.Purpose")}</p>
              <p className="p-pera">{collectiondata1.pra2}</p>
              <p className="p-pera">
                <strong>{collectiondata1.apiname}</strong>
              </p>
              <p className="p-pera">
                <strong>{t("main.developerDocuments.Method")}</strong> {collectiondata1.method}
              </p>
              <p className="p-pera">
                <strong>{t("main.developerDocuments.Endpoint")}</strong> {collectiondata1.apiendponit}
              </p>
              <p className="p-pera">
                <strong>{t("main.developerDocuments.URL")}</strong> {collectiondata1.apiurl}
              </p>
              <p className="error-heading-pra">
                {t("main.developerDocuments.AUTHORIZATION")} <span>{t("main.developerDocuments.Bearer Token")}</span>
              </p>
              <table>
                <tbody>
                  <tr>
                    <td className="error-t-body error-body-text">{t("main.developerDocuments.Token")}</td>
                    <td className="error-t-body-head error-body-text">{`<token>`}</td>
                  </tr>
                </tbody>
              </table>
              <p className="error-heading-pra">{t("main.developerDocuments.HEADERS")}</p>
              <table>
                <tbody>
                  <tr>
                    <td className="error-t-body error-body-text">
                      {collectiondata1.contenttype}
                    </td>
                    <td className="error-t-body-head error-body-text">
                      <p className="p-pera">
                        {collectiondata1.contenttypecontent?.slice(0, 25)}
                        ...
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td className="error-t-body error-body-text">
                      {collectiondata1.accept}
                    </td>
                    <td className="error-t-body-head error-body-text">
                      <p className="p-pera">{collectiondata1.acceptcontent}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="error-heading-pra">{t("main.developerDocuments.Body")}</p>
              <div className="auth-box">
                <div className="auth-pera-box">
                  {collectionRequest1 ? (
                    <Bodytext data={collectionRequest1} />
                  ) : (
                    <p>{t("main.developerDocuments.Loading")}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full">
              <div className="copy-board-box">
                <div className="code-box">
                  <div className="respons-url-box">
                    <p
                      onClick={() =>
                        setOpenCollapse((prev) => ({
                          ...prev,
                          getpaymentdetails: !prev.getpaymentdetails,
                        }))
                      }
                      aria-controls="example-collapse-text"
                      aria-expanded={openCollapse.getpaymentdetails}
                      className="url-but-box"
                    >
                      <>
                        <Button className="but-api-url-method">Post</Button>
                        <span className="url-span">
                          api/pg/pg_transaction_details
                        </span>
                      </>
                      {openCollapse.getpaymentdetails ? (
                        <IoIosArrowUp />
                      ) : (
                        <IoIosArrowDown />
                      )}
                    </p>
                    {openCollapse.getpaymentdetails && (
                      <div id="example-collapse-text" className="collapse-box">
                        <div className="coll-list">
                          <p className="url-show">{collectiondata1.apiurl}</p>
                          <CopyButton textToCopy={collectiondata1.apiurl} />
                        </div>
                      </div>)}
                  </div>

                  <div>
                    <p className="heading-code-box">{t("main.developerDocuments.Response samples")}</p>
                    <Tabs
                      className="mb-3"
                      selectedTabClassName="active response-code-tab"
                      selectedTabPanelClassName="active-panel"
                    >
                      <TabList className="relative identity flex gap-3 items-center nav nav-tabs">
                        {Object.entries(collectionResponses1)
                          .sort(
                            (a, b) =>
                              parseInt(a[0].replace("code", "")) -
                              parseInt(b[0].replace("code", ""))
                          )
                          .map(([codeKey]) => {
                            const tabKey = codeKey.replace("code", "");
                            return (
                              <Tab className="nav-item nav-link" key={codeKey}>
                                {tabKey}
                              </Tab>
                            );
                          })}
                      </TabList>

                      {Object.entries(collectionResponses1)
                        .sort(
                          (a, b) =>
                            parseInt(a[0].replace("code", "")) -
                            parseInt(b[0].replace("code", ""))
                        )
                        .map(([codeKey, responseData]) => (
                          <TabPanel key={codeKey} className="tab-pane">
                            <div className="url-but-box-1">
                              {codeKey === "code200" && (
                                <div className="dropMenu">
                                  <select
                                    id="selectField"
                                    onChange={handleSelectChange}
                                    className="select-box"
                                  >
                                    <option
                                      value="option1"
                                      className="option-h"
                                    >
                                      application/json
                                    </option>
                                    <option
                                      value="option2"
                                      className="option-h"
                                    >
                                      text/json
                                    </option>
                                  </select>
                                </div>
                              )}
                              <Codetext data={responseData} />
                            </div>
                          </TabPanel>
                        ))}
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* *********  Transfer Funds  ********* */}
      <div className="tra-section">
        <div className="mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="w-full">
              <div className="heading-box">
                <h4 className="h4-heading pt-4">{t("main.developerDocuments.Transfer Funds")}</h4>
                <p className="p-pera">{transferfundsdata.pra1}</p>

                <ul>
                  <li>{t("main.developerDocuments.BCTPay creates a transfer session")}</li>
                  <li>{t("main.developerDocuments.You get a checkout URL to complete the payment")}</li>
                  <li>
                    {t("main.developerDocuments.You redirect the recipient")}
                  </li>
                  <li>
                    {t("main.developerDocuments.You can check the status later")}
                  </li>
                </ul>
                <p className="p-pera">
                  <strong>{transferfundsdata.apiname}</strong>
                </p>
                <p className="p-pera">
                  <strong>{t("main.developerDocuments.Method")}</strong> {transferfundsdata.method}
                </p>
                <p className="p-pera">
                  <strong>{t("main.developerDocuments.Endpoint")}</strong> {transferfundsdata.apiendponit}
                </p>
                <p className="p-pera">
                  <strong>{t("main.developerDocuments.URL")}</strong> {transferfundsdata.apiurl}
                </p>
                <p className="error-heading-pra">
                  {t("main.developerDocuments.AUTHORIZATION")} <span>{t("main.developerDocuments.Bearer Token")}</span>
                </p>
                <table>
                  <tbody>
                    <tr>
                      <td className="error-t-body error-body-text">{t("main.developerDocuments.Token")}</td>
                      <td className="error-t-body-head error-body-text">{`<token>`}</td>
                    </tr>
                  </tbody>
                </table>
                <p className="error-heading-pra">{t("main.developerDocuments.HEADERS")}</p>
                <table>
                  <tbody>
                    <tr>
                      <td className="error-t-body error-body-text">
                        {transferfundsdata.contenttype}
                      </td>
                      <td className="error-t-body-head error-body-text">
                        <p className="p-pera">
                          {transferfundsdata.contenttypecontent?.slice(0, 25)}
                          ...
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="error-t-body error-body-text">
                        {transferfundsdata.accept}
                      </td>
                      <td className="error-t-body-head error-body-text">
                        <p className="p-pera">
                          {transferfundsdata.acceptcontent}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="error-heading-pra">{t("main.developerDocuments.Body")}</p>
                <div className="auth-box">
                  <div className="auth-pera-box">
                    {transferfundsrequest ? (
                      <Bodytext data={transferfundsrequest} />
                    ) : (
                      <p>{t("main.developerDocuments.Loading")}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div className="copy-board-box">
                <div className="code-box">
                  <div className="respons-url-box">
                    <p
                      onClick={() =>
                        setOpenCollapse((prev) => ({
                          ...prev,
                          initiatetransfer: !prev.initiatetransfer,
                        }))
                      }
                      aria-controls="example-collapse-text"
                      aria-expanded={openCollapse.initiatetransfer}
                      className="url-but-box"
                    >
                      <>
                        <Button className="but-api-url-method">Post</Button>
                        <span className="url-span">
                          /api/pg/pg_initiate_payment_transfer
                        </span>
                      </>
                      {openCollapse.initiatetransfer ? (
                        <IoIosArrowUp />
                      ) : (
                        <IoIosArrowDown />
                      )}
                    </p>
                    {openCollapse.initiatetransfer && (
                      <div id="example-collapse-text" className="collapse-box">
                        <div className="coll-list">
                          <p className="url-show">{transferfundsdata.apiurl}</p>
                          <CopyButton textToCopy={transferfundsdata.apiurl} />
                        </div>
                      </div>)}
                  </div>

                  <div>
                    <p className="heading-code-box">{t("main.developerDocuments.Response samples")}</p>

                    <Tabs
                      className="mb-3"
                      selectedTabClassName="active response-code-tab"
                      selectedTabPanelClassName="active-panel"
                    >
                      <TabList className="relative identity flex gap-3 items-center nav nav-tabs">
                        {Object.entries(transferfundsResponses)
                          .sort(
                            (a, b) =>
                              parseInt(a[0].replace("code", "")) -
                              parseInt(b[0].replace("code", ""))
                          )
                          .map(([codeKey]) => {
                            const tabKey = codeKey.replace("code", "");
                            return (
                              <Tab className="nav-item nav-link" key={codeKey}>
                                {tabKey}
                              </Tab>
                            );
                          })}
                      </TabList>

                      {Object.entries(transferfundsResponses)
                        .sort(
                          (a, b) =>
                            parseInt(a[0].replace("code", "")) -
                            parseInt(b[0].replace("code", ""))
                        )
                        .map(([codeKey, responseData]) => (
                          <TabPanel key={codeKey} className="tab-pane">
                            <div className="url-but-box-1">
                              {codeKey === "code200" && (
                                <div className="dropMenu">
                                  <select
                                    id="selectField"
                                    onChange={handleSelectChange}
                                    className="select-box"
                                  >
                                    <option
                                      value="option1"
                                      className="option-h"
                                    >
                                      application/json
                                    </option>
                                    <option
                                      value="option2"
                                      className="option-h"
                                    >
                                      text/json
                                    </option>
                                  </select>
                                </div>
                              )}
                              <Codetext data={responseData} />
                            </div>
                          </TabPanel>
                        ))}
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="" style={{ marginTop: "120px" }}>
          <div className="grid grid-cols-2 gap-4">
            <div className="w-full">
              <p className="error-heading-pra">{t("main.developerDocuments.Purpose")}</p>
              <p className="p-pera">{transferfundsdata1.pra1}</p>
              <p className="p-pera">
                <strong>{transferfundsdata1.apiname}</strong>
              </p>
              <p className="p-pera">
                <strong>{t("main.developerDocuments.Method")}</strong> {transferfundsdata1.method}
              </p>
              <p className="p-pera">
                <strong>{t("main.developerDocuments.Endpoint")}</strong> {transferfundsdata1.apiendponit}
              </p>
              <p className="p-pera">
                <strong>{t("main.developerDocuments.URL")}</strong> {transferfundsdata1.apiurl}
              </p>
              <p className="error-heading-pra">
                {t("main.developerDocuments.AUTHORIZATION")} <span>{t("main.developerDocuments.Bearer Token")}</span>
              </p>
              <table>
                <tbody>
                  <tr>
                    <td className="error-t-body error-body-text">{t("main.developerDocuments.Token")}</td>
                    <td className="error-t-body-head error-body-text">{`<token>`}</td>
                  </tr>
                </tbody>
              </table>
              <p className="error-heading-pra">{t("main.developerDocuments.HEADERS")}</p>
              <table>
                <tbody>
                  <tr>
                    <td className="error-t-body error-body-text">
                      {transferfundsdata1.contenttype}
                    </td>
                    <td className="error-t-body-head error-body-text">
                      <p className="p-pera">
                        {transferfundsdata1.contenttypecontent?.slice(0, 25)}
                        ...
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td className="error-t-body error-body-text">
                      {transferfundsdata1.accept}
                    </td>
                    <td className="error-t-body-head error-body-text">
                      <p className="p-pera">
                        {transferfundsdata1.acceptcontent}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="error-heading-pra">{t("main.developerDocuments.Body")}</p>
              <div className="auth-box">
                <div className="auth-pera-box">
                  {transferfundsrequest1 ? (
                    <Bodytext data={transferfundsrequest1} />
                  ) : (
                    <p>{t("main.developerDocuments.Loading")}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full">
              <div className="copy-board-box">
                <div className="code-box">
                  <div className="respons-url-box">
                    <p
                      onClick={() =>
                        setOpenCollapse((prev) => ({
                          ...prev,
                          getpaymentdetailsbyid: !prev.getpaymentdetailsbyid,
                        }))
                      }
                      aria-controls="example-collapse-text"
                      aria-expanded={openCollapse.getpaymentdetailsbyid}
                      className="url-but-box"
                    >
                      <>
                        <Button className="but-api-url-method">{t("main.developerDocuments.Post")}</Button>
                        <span className="url-span">
                          /api/pg/pg_transaction_details
                        </span>
                      </>
                      {openCollapse.getpaymentdetailsbyid ? (
                        <IoIosArrowUp />
                      ) : (
                        <IoIosArrowDown />
                      )}
                    </p>
                    {openCollapse.getpaymentdetailsbyid && (
                      <div id="example-collapse-text" className="collapse-box">
                        <div className="coll-list">
                          <p className="url-show">
                            {transferfundsdata1.apiurl}
                          </p>
                          <CopyButton textToCopy={transferfundsdata1.apiurl} />
                        </div>
                      </div>)}
                  </div>

                  <div>
                    <p className="heading-code-box">{t("main.developerDocuments.Response samples")}</p>

                    <Tabs
                      className="mb-3"
                      selectedTabClassName="active response-code-tab"
                      selectedTabPanelClassName="active-panel"
                    >
                      <TabList className="relative identity flex gap-3 items-center nav nav-tabs">
                        {Object.entries(transferfundsResponses1)
                          .sort(
                            (a, b) =>
                              parseInt(a[0].replace("code", "")) -
                              parseInt(b[0].replace("code", ""))
                          )
                          .map(([codeKey]) => {
                            const tabKey = codeKey.replace("code", "");
                            return (
                              <Tab className="nav-item nav-link" key={codeKey}>
                                {tabKey}
                              </Tab>
                            );
                          })}
                      </TabList>

                      {Object.entries(transferfundsResponses1)
                        .sort(
                          (a, b) =>
                            parseInt(a[0].replace("code", "")) -
                            parseInt(b[0].replace("code", ""))
                        )
                        .map(([codeKey, responseData]) => (
                          <TabPanel key={codeKey} className="tab-pane">
                            <div className="url-but-box-1">
                              {codeKey === "code200" && (
                                <div className="dropMenu">
                                  <select
                                    id="selectField"
                                    onChange={handleSelectChange}
                                    className="select-box"
                                  >
                                    <option
                                      value="option1"
                                      className="option-h"
                                    >
                                      application/json
                                    </option>
                                    <option
                                      value="option2"
                                      className="option-h"
                                    >
                                      text/json
                                    </option>
                                  </select>
                                </div>
                              )}
                              <Codetext data={responseData} />
                            </div>
                          </TabPanel>
                        ))}
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
